<div [id]='this.id' class='bm-int-card bm-full-width'>

  <ng-container *ngIf='images'>
    <ng-container *ngFor='let image of images; index as i'>
      <img
        *ngIf='image.static'
        [class]='image?.class'
        [src]='image.src'
        [style]="image.style + 'animation-delay:'+ (i+1)*333+'ms;'+'transform:perspective(none) translateZ(0) rotateX(none) rotateY(none)'"
      />
      <img
        *ngIf='!image.static'
        [class]='image?.class'
        [src]='image.src'
        [style]="image.style + 'animation-delay:'+ (i+1)*333+'ms;'+'transform:perspective(525px) translateZ(0) rotateX(var(--dx)) rotateY(var(--dy))'"
      />
    </ng-container>
  </ng-container>
</div>
